import { defineComponent as _defineComponent } from 'vue'
import { useUserStore } from '@/js/lib/store/user';
import { useItemStore } from '@/js/lib/store/item';
import FollowRecommend from './followRecommend.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'followRecommendIfItemLiked',
  props: {
    itemId: { default: undefined },
    memberId: null
  },
  setup(__props: any) {


const userStore = useUserStore();
const itemStore = useItemStore();

return { __sfc: true,userStore, itemStore, FollowRecommend }
}

})